export default __webpack_public_path__ + "static/media/dbcg.d22999da.jpg";